<template>
  <div class="tw-flex tw-gap-2 tw-items-start">
    <img
      :src="require('@/assets/images/onboarding/doctor-image.png')"
      alt=""
      class="tw-h-[70px] tw-mr-2"
    >
    <h2
      class="tw-mb-0 tw-flex-1 question-title tw-font-atten"
    >
      <slot></slot>
    </h2>
  </div>
</template>
<script>
export default {
  name: 'DoctorHeader'
};
</script>